//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BestResultsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7151";

    }

    getMinMaxOutputValues(experimentId: number | null | undefined, experimentVersionId: number | null | undefined, cancelToken?: CancelToken): Promise<ComponentMinMaxResponseModel[]> {
        let url_ = this.baseUrl + "/api/best-results/min-max-values?";
        if (experimentId !== undefined && experimentId !== null)
            url_ += "ExperimentId=" + encodeURIComponent("" + experimentId) + "&";
        if (experimentVersionId !== undefined && experimentVersionId !== null)
            url_ += "ExperimentVersionId=" + encodeURIComponent("" + experimentVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMinMaxOutputValues(_response);
        });
    }

    protected processGetMinMaxOutputValues(response: AxiosResponse): Promise<ComponentMinMaxResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentMinMaxResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ComponentMinMaxResponseModel[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComponentMinMaxResponseModel[]>(null as any);
    }
}

export class CalculationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7151";

    }

    saveJobResult(model: CalculationJobPostModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/calculations/job-result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveJobResult(_response);
        });
    }

    protected processSaveJobResult(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveJobFlowsheet(file: FileParameter | null | undefined, experimentVersionId: number | undefined, sequenceId: number | undefined, index: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/calculations/job-flowsheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (experimentVersionId === null || experimentVersionId === undefined)
            throw new Error("The parameter 'experimentVersionId' cannot be null.");
        else
            content_.append("ExperimentVersionId", experimentVersionId.toString());
        if (sequenceId === null || sequenceId === undefined)
            throw new Error("The parameter 'sequenceId' cannot be null.");
        else
            content_.append("SequenceId", sequenceId.toString());
        if (index === null || index === undefined)
            throw new Error("The parameter 'index' cannot be null.");
        else
            content_.append("Index", index.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveJobFlowsheet(_response);
        });
    }

    protected processSaveJobFlowsheet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    statusUpdateCallback(model: ExperimentStatusPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/callculations/status-update-callback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatusUpdateCallback(_response);
        });
    }

    protected processStatusUpdateCallback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ComponentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7151";

    }

    getAllDwsimComponents( cancelToken?: CancelToken): Promise<ComponentResponseModel[]> {
        let url_ = this.baseUrl + "/api/components";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDwsimComponents(_response);
        });
    }

    protected processGetAllDwsimComponents(response: AxiosResponse): Promise<ComponentResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ComponentResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComponentResponseModel[]>(null as any);
    }
}

export class ElasticSearchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7151";

    }

    reindexAllCalculationJobResults( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/elastic-search/reindex-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReindexAllCalculationJobResults(_response);
        });
    }

    protected processReindexAllCalculationJobResults(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getExperimentResultData(userQuery: ExperimentDataQuery, cancelToken?: CancelToken): Promise<ExperimentDataResultModel> {
        let url_ = this.baseUrl + "/api/elastic-search/get-experiment-result-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userQuery);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperimentResultData(_response);
        });
    }

    protected processGetExperimentResultData(response: AxiosResponse): Promise<ExperimentDataResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExperimentDataResultModel.fromJS(resultData200);
            return Promise.resolve<ExperimentDataResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExperimentDataResultModel>(null as any);
    }

    getExperimentBestResults(query: BestResultsQuery, cancelToken?: CancelToken): Promise<CalculationJobResultModel[]> {
        let url_ = this.baseUrl + "/api/elastic-search/get-experiment-best-results";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperimentBestResults(_response);
        });
    }

    protected processGetExperimentBestResults(response: AxiosResponse): Promise<CalculationJobResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationJobResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CalculationJobResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationJobResultModel[]>(null as any);
    }

    getCalculationJobDetails(experimentVersionId: number, sequence: number, flowsheetId: number, cancelToken?: CancelToken): Promise<CalculationJobResultModel> {
        let url_ = this.baseUrl + "/api/elastic-search/{experimentVersionId}/calculation-job/{sequence}/{flowsheetId}";
        if (experimentVersionId === undefined || experimentVersionId === null)
            throw new Error("The parameter 'experimentVersionId' must be defined.");
        url_ = url_.replace("{experimentVersionId}", encodeURIComponent("" + experimentVersionId));
        if (sequence === undefined || sequence === null)
            throw new Error("The parameter 'sequence' must be defined.");
        url_ = url_.replace("{sequence}", encodeURIComponent("" + sequence));
        if (flowsheetId === undefined || flowsheetId === null)
            throw new Error("The parameter 'flowsheetId' must be defined.");
        url_ = url_.replace("{flowsheetId}", encodeURIComponent("" + flowsheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCalculationJobDetails(_response);
        });
    }

    protected processGetCalculationJobDetails(response: AxiosResponse): Promise<CalculationJobResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculationJobResultModel.fromJS(resultData200);
            return Promise.resolve<CalculationJobResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationJobResultModel>(null as any);
    }

    getExperimentResultSequenceList(experimentVersionId: number, cancelToken?: CancelToken): Promise<ExperimentResultSequencesResponseModel> {
        let url_ = this.baseUrl + "/api/elastic-search/{experimentVersionId}/experiment-sequence-number";
        if (experimentVersionId === undefined || experimentVersionId === null)
            throw new Error("The parameter 'experimentVersionId' must be defined.");
        url_ = url_.replace("{experimentVersionId}", encodeURIComponent("" + experimentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperimentResultSequenceList(_response);
        });
    }

    protected processGetExperimentResultSequenceList(response: AxiosResponse): Promise<ExperimentResultSequencesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExperimentResultSequencesResponseModel.fromJS(resultData200);
            return Promise.resolve<ExperimentResultSequencesResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExperimentResultSequencesResponseModel>(null as any);
    }

    getExperimentSequenceGraphData(experimentVersionId: number, sequenceId: number, cancelToken?: CancelToken): Promise<CalculationJobResultModel[]> {
        let url_ = this.baseUrl + "/api/elastic-search/{experimentVersionId}/{sequenceId}/graph-data";
        if (experimentVersionId === undefined || experimentVersionId === null)
            throw new Error("The parameter 'experimentVersionId' must be defined.");
        url_ = url_.replace("{experimentVersionId}", encodeURIComponent("" + experimentVersionId));
        if (sequenceId === undefined || sequenceId === null)
            throw new Error("The parameter 'sequenceId' must be defined.");
        url_ = url_.replace("{sequenceId}", encodeURIComponent("" + sequenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperimentSequenceGraphData(_response);
        });
    }

    protected processGetExperimentSequenceGraphData(response: AxiosResponse): Promise<CalculationJobResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationJobResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CalculationJobResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculationJobResultModel[]>(null as any);
    }
}

export class ExperimentCountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7151";

    }

    getExperimentCount(model: ExperimentCountPostModel, cancelToken?: CancelToken): Promise<ExperimentCountResponseModel[]> {
        let url_ = this.baseUrl + "/api/scenario-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperimentCount(_response);
        });
    }

    protected processGetExperimentCount(response: AxiosResponse): Promise<ExperimentCountResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExperimentCountResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ExperimentCountResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExperimentCountResponseModel[]>(null as any);
    }
}

export class ExperimentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7151";

    }

    getExperiments(flowsheetId: string, cancelToken?: CancelToken): Promise<ExperimentForListResponseModel[]> {
        let url_ = this.baseUrl + "/api/experiments/{flowsheetId}";
        if (flowsheetId === undefined || flowsheetId === null)
            throw new Error("The parameter 'flowsheetId' must be defined.");
        url_ = url_.replace("{flowsheetId}", encodeURIComponent("" + flowsheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperiments(_response);
        });
    }

    protected processGetExperiments(response: AxiosResponse): Promise<ExperimentForListResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExperimentForListResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ExperimentForListResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExperimentForListResponseModel[]>(null as any);
    }

    getExperiment(flowsheetUniqueId: string, experimentId: number, cancelToken?: CancelToken): Promise<ExperimentResponseModel> {
        let url_ = this.baseUrl + "/api/experiments/{flowsheetUniqueId}/{experimentId}";
        if (flowsheetUniqueId === undefined || flowsheetUniqueId === null)
            throw new Error("The parameter 'flowsheetUniqueId' must be defined.");
        url_ = url_.replace("{flowsheetUniqueId}", encodeURIComponent("" + flowsheetUniqueId));
        if (experimentId === undefined || experimentId === null)
            throw new Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperiment(_response);
        });
    }

    protected processGetExperiment(response: AxiosResponse): Promise<ExperimentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExperimentResponseModel.fromJS(resultData200);
            return Promise.resolve<ExperimentResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExperimentResponseModel>(null as any);
    }

    getExperimentById(experimentId: number, skipDataCheck: boolean | null | undefined, cancelToken?: CancelToken): Promise<ExperimentResponseModel> {
        let url_ = this.baseUrl + "/api/experiments/by-id/{experimentId}?";
        if (experimentId === undefined || experimentId === null)
            throw new Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        if (skipDataCheck !== undefined && skipDataCheck !== null)
            url_ += "skipDataCheck=" + encodeURIComponent("" + skipDataCheck) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperimentById(_response);
        });
    }

    protected processGetExperimentById(response: AxiosResponse): Promise<ExperimentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExperimentResponseModel.fromJS(resultData200);
            return Promise.resolve<ExperimentResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExperimentResponseModel>(null as any);
    }

    getAllUserExperiments(skip: number | undefined, take: number | undefined, orderByIdDesc: boolean | undefined, cancelToken?: CancelToken): Promise<ExperimentListResponseModel> {
        let url_ = this.baseUrl + "/api/experiments/all-user-experiments?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (orderByIdDesc === null)
            throw new Error("The parameter 'orderByIdDesc' cannot be null.");
        else if (orderByIdDesc !== undefined)
            url_ += "OrderByIdDesc=" + encodeURIComponent("" + orderByIdDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserExperiments(_response);
        });
    }

    protected processGetAllUserExperiments(response: AxiosResponse): Promise<ExperimentListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExperimentListResponseModel.fromJS(resultData200);
            return Promise.resolve<ExperimentListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExperimentListResponseModel>(null as any);
    }

    createOrUpdateExperiment(model: ExperimentPostModel, cancelToken?: CancelToken): Promise<EditExperimentResponseModel> {
        let url_ = this.baseUrl + "/api/experiments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateExperiment(_response);
        });
    }

    protected processCreateOrUpdateExperiment(response: AxiosResponse): Promise<EditExperimentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditExperimentResponseModel.fromJS(resultData200);
            return Promise.resolve<EditExperimentResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditExperimentResponseModel>(null as any);
    }

    downloadYML(flowsheetUniqueId: string, experimentId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/experiments/{flowsheetUniqueId}/{experimentId}/download-yml";
        if (flowsheetUniqueId === undefined || flowsheetUniqueId === null)
            throw new Error("The parameter 'flowsheetUniqueId' must be defined.");
        url_ = url_.replace("{flowsheetUniqueId}", encodeURIComponent("" + flowsheetUniqueId));
        if (experimentId === undefined || experimentId === null)
            throw new Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadYML(_response);
        });
    }

    protected processDownloadYML(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadFlowsheet(experimentVersionId: number, sequence: number, flowsheetId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/experiments/{experimentVersionId}/{sequence}/{flowsheetId}/download";
        if (experimentVersionId === undefined || experimentVersionId === null)
            throw new Error("The parameter 'experimentVersionId' must be defined.");
        url_ = url_.replace("{experimentVersionId}", encodeURIComponent("" + experimentVersionId));
        if (sequence === undefined || sequence === null)
            throw new Error("The parameter 'sequence' must be defined.");
        url_ = url_.replace("{sequence}", encodeURIComponent("" + sequence));
        if (flowsheetId === undefined || flowsheetId === null)
            throw new Error("The parameter 'flowsheetId' must be defined.");
        url_ = url_.replace("{flowsheetId}", encodeURIComponent("" + flowsheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFlowsheet(_response);
        });
    }

    protected processDownloadFlowsheet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveFlowsheetToDashboard(model: SaveExperimentFlowsheetPostModel, cancelToken?: CancelToken): Promise<FlowsheetSavedResponseModel> {
        let url_ = this.baseUrl + "/api/experiments/save-to-dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveFlowsheetToDashboard(_response);
        });
    }

    protected processSaveFlowsheetToDashboard(response: AxiosResponse): Promise<FlowsheetSavedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlowsheetSavedResponseModel.fromJS(resultData200);
            return Promise.resolve<FlowsheetSavedResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlowsheetSavedResponseModel>(null as any);
    }

    deleteExperiment(experimentId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/experiments/{experimentId}";
        if (experimentId === undefined || experimentId === null)
            throw new Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExperiment(_response);
        });
    }

    protected processDeleteExperiment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    restoreExperiment(experimentId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/experiments/{experimentId}/restore";
        if (experimentId === undefined || experimentId === null)
            throw new Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreExperiment(_response);
        });
    }

    protected processRestoreExperiment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LicensingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7151";

    }

    getLicenseStatus( cancelToken?: CancelToken): Promise<LicenseResponseModel> {
        let url_ = this.baseUrl + "/api/licensing/license-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseStatus(_response);
        });
    }

    protected processGetLicenseStatus(response: AxiosResponse): Promise<LicenseResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenseResponseModel.fromJS(resultData200);
            return Promise.resolve<LicenseResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseResponseModel>(null as any);
    }
}

export class ProcessingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7151";

    }

    start(model: StartExperimentCalculationPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/processing/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    stop(model: StopExperimentCalculationPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/processing/stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    canUserStartExperiment(experimentId: number | undefined, experimentVersionId: number | undefined, cancelToken?: CancelToken): Promise<CanStartExperimentResponseModel> {
        let url_ = this.baseUrl + "/api/processing/check-can-start?";
        if (experimentId === null)
            throw new Error("The parameter 'experimentId' cannot be null.");
        else if (experimentId !== undefined)
            url_ += "experimentId=" + encodeURIComponent("" + experimentId) + "&";
        if (experimentVersionId === null)
            throw new Error("The parameter 'experimentVersionId' cannot be null.");
        else if (experimentVersionId !== undefined)
            url_ += "experimentVersionId=" + encodeURIComponent("" + experimentVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCanUserStartExperiment(_response);
        });
    }

    protected processCanUserStartExperiment(response: AxiosResponse): Promise<CanStartExperimentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CanStartExperimentResponseModel.fromJS(resultData200);
            return Promise.resolve<CanStartExperimentResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CanStartExperimentResponseModel>(null as any);
    }
}

export class ComponentMinMaxResponseModel implements IComponentMinMaxResponseModel {
    name?: string;
    casNr?: string;
    min?: number | undefined;
    max?: number | undefined;

    constructor(data?: IComponentMinMaxResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.casNr = _data["casNr"];
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): ComponentMinMaxResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentMinMaxResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["casNr"] = this.casNr;
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}

export interface IComponentMinMaxResponseModel {
    name?: string;
    casNr?: string;
    min?: number | undefined;
    max?: number | undefined;
}

export class ErrorResponseModel implements IErrorResponseModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (<any>this.validationErrors)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (<any>data["validationErrors"])[key] = (<any>this.validationErrors)[key];
            }
        }
        return data;
    }
}

export interface IErrorResponseModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class CalculationJobPostModel implements ICalculationJobPostModel {
    experimentVersionId!: number;
    status!: CalculationRunJobStatus;
    sequence!: number;
    index!: number;
    parameters!: JobParameterPostModel[];
    purities!: JobPurityPostModel[];
    objectives!: JobObjectivePostModel[];
    energy!: number;
    capex!: number;
    opex!: number;
    note?: string;
    calculatonTime!: number;

    constructor(data?: ICalculationJobPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.parameters = [];
            this.purities = [];
            this.objectives = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentVersionId = _data["experimentVersionId"];
            this.status = _data["status"];
            this.sequence = _data["sequence"];
            this.index = _data["index"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(JobParameterPostModel.fromJS(item));
            }
            if (Array.isArray(_data["purities"])) {
                this.purities = [] as any;
                for (let item of _data["purities"])
                    this.purities!.push(JobPurityPostModel.fromJS(item));
            }
            if (Array.isArray(_data["objectives"])) {
                this.objectives = [] as any;
                for (let item of _data["objectives"])
                    this.objectives!.push(JobObjectivePostModel.fromJS(item));
            }
            this.energy = _data["energy"];
            this.capex = _data["capex"];
            this.opex = _data["opex"];
            this.note = _data["note"];
            this.calculatonTime = _data["calculatonTime"];
        }
    }

    static fromJS(data: any): CalculationJobPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationJobPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentVersionId"] = this.experimentVersionId;
        data["status"] = this.status;
        data["sequence"] = this.sequence;
        data["index"] = this.index;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        if (Array.isArray(this.purities)) {
            data["purities"] = [];
            for (let item of this.purities)
                data["purities"].push(item.toJSON());
        }
        if (Array.isArray(this.objectives)) {
            data["objectives"] = [];
            for (let item of this.objectives)
                data["objectives"].push(item.toJSON());
        }
        data["energy"] = this.energy;
        data["capex"] = this.capex;
        data["opex"] = this.opex;
        data["note"] = this.note;
        data["calculatonTime"] = this.calculatonTime;
        return data;
    }
}

export interface ICalculationJobPostModel {
    experimentVersionId: number;
    status: CalculationRunJobStatus;
    sequence: number;
    index: number;
    parameters: JobParameterPostModel[];
    purities: JobPurityPostModel[];
    objectives: JobObjectivePostModel[];
    energy: number;
    capex: number;
    opex: number;
    note?: string;
    calculatonTime: number;
}

export enum CalculationRunJobStatus {
    Calculated = 0,
    Failed = 1,
}

export class JobParameterPostModel implements IJobParameterPostModel {
    parameter!: string;
    value!: number;

    constructor(data?: IJobParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): JobParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface IJobParameterPostModel {
    parameter: string;
    value: number;
}

export class JobPurityPostModel implements IJobPurityPostModel {
    componentCasNumber!: string;
    value!: number;

    constructor(data?: IJobPurityPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentCasNumber = _data["componentCasNumber"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): JobPurityPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobPurityPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentCasNumber"] = this.componentCasNumber;
        data["value"] = this.value;
        return data;
    }
}

export interface IJobPurityPostModel {
    componentCasNumber: string;
    value: number;
}

export class JobObjectivePostModel implements IJobObjectivePostModel {
    componentCasNumber!: string;
    value!: number;

    constructor(data?: IJobObjectivePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentCasNumber = _data["componentCasNumber"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): JobObjectivePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobObjectivePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentCasNumber"] = this.componentCasNumber;
        data["value"] = this.value;
        return data;
    }
}

export interface IJobObjectivePostModel {
    componentCasNumber: string;
    value: number;
}

export class ExperimentStatusPostModel implements IExperimentStatusPostModel {
    experimentVersionId?: number;
    status?: ProcessingStatus;
    errorMessage?: string;

    constructor(data?: IExperimentStatusPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentVersionId = _data["experimentVersionId"];
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ExperimentStatusPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentStatusPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentVersionId"] = this.experimentVersionId;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IExperimentStatusPostModel {
    experimentVersionId?: number;
    status?: ProcessingStatus;
    errorMessage?: string;
}

export enum ProcessingStatus {
    Running = 1,
    Finished = 2,
    Failed = 3,
}

export class ComponentResponseModel implements IComponentResponseModel {
    name?: string;
    casNr?: string;

    constructor(data?: IComponentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.casNr = _data["casNr"];
        }
    }

    static fromJS(data: any): ComponentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["casNr"] = this.casNr;
        return data;
    }
}

export interface IComponentResponseModel {
    name?: string;
    casNr?: string;
}

export class ExperimentDataResultModel implements IExperimentDataResultModel {
    rows?: CalculationJobResultModel[];
    totalRecords?: number;

    constructor(data?: IExperimentDataResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CalculationJobResultModel.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): ExperimentDataResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentDataResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IExperimentDataResultModel {
    rows?: CalculationJobResultModel[];
    totalRecords?: number;
}

export class CalculationJobResultModel implements ICalculationJobResultModel {
    calculationRun_JobId?: number;
    sequence?: number;
    flowsheetId?: number;
    status?: CalculationRunJobStatus;
    energy?: number;
    capex?: number;
    opex?: number;
    inputs?: CalculationJobInputModel[];
    results?: CalculationJobOutputModel[];
    note?: string;

    constructor(data?: ICalculationJobResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationRun_JobId = _data["calculationRun_JobId"];
            this.sequence = _data["sequence"];
            this.flowsheetId = _data["flowsheetId"];
            this.status = _data["status"];
            this.energy = _data["energy"];
            this.capex = _data["capex"];
            this.opex = _data["opex"];
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(CalculationJobInputModel.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CalculationJobOutputModel.fromJS(item));
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CalculationJobResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationJobResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationRun_JobId"] = this.calculationRun_JobId;
        data["sequence"] = this.sequence;
        data["flowsheetId"] = this.flowsheetId;
        data["status"] = this.status;
        data["energy"] = this.energy;
        data["capex"] = this.capex;
        data["opex"] = this.opex;
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["note"] = this.note;
        return data;
    }
}

export interface ICalculationJobResultModel {
    calculationRun_JobId?: number;
    sequence?: number;
    flowsheetId?: number;
    status?: CalculationRunJobStatus;
    energy?: number;
    capex?: number;
    opex?: number;
    inputs?: CalculationJobInputModel[];
    results?: CalculationJobOutputModel[];
    note?: string;
}

export class CalculationJobInputModel implements ICalculationJobInputModel {
    parameter?: string;
    value?: number;

    constructor(data?: ICalculationJobInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CalculationJobInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationJobInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface ICalculationJobInputModel {
    parameter?: string;
    value?: number;
}

export class CalculationJobOutputModel implements ICalculationJobOutputModel {
    caS_Number?: string;
    value?: number;

    constructor(data?: ICalculationJobOutputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caS_Number = _data["caS_Number"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CalculationJobOutputModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationJobOutputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caS_Number"] = this.caS_Number;
        data["value"] = this.value;
        return data;
    }
}

export interface ICalculationJobOutputModel {
    caS_Number?: string;
    value?: number;
}

export class ExperimentDataQuery implements IExperimentDataQuery {
    orderBy?: string;
    orderByDescending?: boolean;
    status?: CalculationRunJobStatus | undefined;
    sequence?: number | undefined;
    flowsheetId?: number | undefined;
    experimentVersionId?: number;
    parameterFilter?: ParameterFilter;
    skip?: number;
    take?: number;

    constructor(data?: IExperimentDataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderBy = _data["orderBy"];
            this.orderByDescending = _data["orderByDescending"];
            this.status = _data["status"];
            this.sequence = _data["sequence"];
            this.flowsheetId = _data["flowsheetId"];
            this.experimentVersionId = _data["experimentVersionId"];
            this.parameterFilter = _data["parameterFilter"] ? ParameterFilter.fromJS(_data["parameterFilter"]) : <any>undefined;
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): ExperimentDataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentDataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderBy"] = this.orderBy;
        data["orderByDescending"] = this.orderByDescending;
        data["status"] = this.status;
        data["sequence"] = this.sequence;
        data["flowsheetId"] = this.flowsheetId;
        data["experimentVersionId"] = this.experimentVersionId;
        data["parameterFilter"] = this.parameterFilter ? this.parameterFilter.toJSON() : <any>undefined;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IExperimentDataQuery {
    orderBy?: string;
    orderByDescending?: boolean;
    status?: CalculationRunJobStatus | undefined;
    sequence?: number | undefined;
    flowsheetId?: number | undefined;
    experimentVersionId?: number;
    parameterFilter?: ParameterFilter;
    skip?: number;
    take?: number;
}

export class ParameterFilter implements IParameterFilter {
    parameterId?: string;
    filterOperation?: FilterOperation;
    equalsValue?: number | undefined;
    endsValue?: number | undefined;

    constructor(data?: IParameterFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterId = _data["parameterId"];
            this.filterOperation = _data["filterOperation"];
            this.equalsValue = _data["equalsValue"];
            this.endsValue = _data["endsValue"];
        }
    }

    static fromJS(data: any): ParameterFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterId"] = this.parameterId;
        data["filterOperation"] = this.filterOperation;
        data["equalsValue"] = this.equalsValue;
        data["endsValue"] = this.endsValue;
        return data;
    }
}

export interface IParameterFilter {
    parameterId?: string;
    filterOperation?: FilterOperation;
    equalsValue?: number | undefined;
    endsValue?: number | undefined;
}

export enum FilterOperation {
    Equals = 0,
    Between = 1,
}

export class BestResultsQuery implements IBestResultsQuery {
    experimentVersionId!: number;
    criteria!: BestResultCriteria;
    filterRanges?: OutputParameterFilter[];

    constructor(data?: IBestResultsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentVersionId = _data["experimentVersionId"];
            this.criteria = _data["criteria"];
            if (Array.isArray(_data["filterRanges"])) {
                this.filterRanges = [] as any;
                for (let item of _data["filterRanges"])
                    this.filterRanges!.push(OutputParameterFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BestResultsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BestResultsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentVersionId"] = this.experimentVersionId;
        data["criteria"] = this.criteria;
        if (Array.isArray(this.filterRanges)) {
            data["filterRanges"] = [];
            for (let item of this.filterRanges)
                data["filterRanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBestResultsQuery {
    experimentVersionId: number;
    criteria: BestResultCriteria;
    filterRanges?: OutputParameterFilter[];
}

export enum BestResultCriteria {
    Purity = 1,
    Pareto = 2,
}

export class OutputParameterFilter implements IOutputParameterFilter {
    componentCasNr?: string;
    min?: number | undefined;
    max?: number | undefined;
    factor?: number | undefined;

    constructor(data?: IOutputParameterFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentCasNr = _data["componentCasNr"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.factor = _data["factor"];
        }
    }

    static fromJS(data: any): OutputParameterFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OutputParameterFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentCasNr"] = this.componentCasNr;
        data["min"] = this.min;
        data["max"] = this.max;
        data["factor"] = this.factor;
        return data;
    }
}

export interface IOutputParameterFilter {
    componentCasNr?: string;
    min?: number | undefined;
    max?: number | undefined;
    factor?: number | undefined;
}

export class ExperimentResultSequencesResponseModel implements IExperimentResultSequencesResponseModel {
    sequences?: number[];

    constructor(data?: IExperimentResultSequencesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sequences"])) {
                this.sequences = [] as any;
                for (let item of _data["sequences"])
                    this.sequences!.push(item);
            }
        }
    }

    static fromJS(data: any): ExperimentResultSequencesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentResultSequencesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sequences)) {
            data["sequences"] = [];
            for (let item of this.sequences)
                data["sequences"].push(item);
        }
        return data;
    }
}

export interface IExperimentResultSequencesResponseModel {
    sequences?: number[];
}

export class ExperimentCountResponseModel implements IExperimentCountResponseModel {
    fileUniqueId?: string;
    count?: number;

    constructor(data?: IExperimentCountResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUniqueId = _data["fileUniqueId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ExperimentCountResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentCountResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUniqueId"] = this.fileUniqueId;
        data["count"] = this.count;
        return data;
    }
}

export interface IExperimentCountResponseModel {
    fileUniqueId?: string;
    count?: number;
}

export class ExperimentCountPostModel implements IExperimentCountPostModel {
    fileUniqueIds?: string[];

    constructor(data?: IExperimentCountPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileUniqueIds"])) {
                this.fileUniqueIds = [] as any;
                for (let item of _data["fileUniqueIds"])
                    this.fileUniqueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExperimentCountPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentCountPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileUniqueIds)) {
            data["fileUniqueIds"] = [];
            for (let item of this.fileUniqueIds)
                data["fileUniqueIds"].push(item);
        }
        return data;
    }
}

export interface IExperimentCountPostModel {
    fileUniqueIds?: string[];
}

export class ExperimentForListResponseModel implements IExperimentForListResponseModel {
    id?: number;
    name?: string;
    createdAt?: Date;
    propertyPackage?: PropertyPackageOption;
    processingStatus?: ExperimentProcessingStatus | undefined;
    isDeleted?: boolean;

    constructor(data?: IExperimentForListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.propertyPackage = _data["propertyPackage"];
            this.processingStatus = _data["processingStatus"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ExperimentForListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentForListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["propertyPackage"] = this.propertyPackage;
        data["processingStatus"] = this.processingStatus;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IExperimentForListResponseModel {
    id?: number;
    name?: string;
    createdAt?: Date;
    propertyPackage?: PropertyPackageOption;
    processingStatus?: ExperimentProcessingStatus | undefined;
    isDeleted?: boolean;
}

export enum PropertyPackageOption {
    NRTL = 1,
    MODFAC = 2,
    PengRobinson = 3,
}

export enum ExperimentProcessingStatus {
    Draft = 0,
    Initializing = 1,
    Running = 2,
    Finished = 3,
    Stopped = 4,
    Failed = 5,
}

export class ExperimentResponseModel implements IExperimentResponseModel {
    id?: number;
    experimentVersionId?: number;
    name?: string;
    flowsheetUniqueId?: string;
    flowsheetVersion?: number | undefined;
    processingStatus?: ExperimentProcessingStatus | undefined;
    propertyPackage?: PropertyPackageOption | undefined;
    separationMethod?: SeparationMethodOption | undefined;
    components?: ExperimentComponentResponseModel[];
    streams?: ExperimentStreamResponseModel[];
    specifications?: ExperimentSpecificationPropertyResponseModel[];
    convergenceTimeout?: number | undefined;
    internalTolerance?: number | undefined;
    externalTolerance?: number | undefined;
    maximumCost?: number | undefined;
    createdAt?: Date;
    errorMessage?: string;
    totalFlowsheets?: number;
    totalConverged?: number;
    totalNotConverged?: number;
    isDeleted?: boolean;

    constructor(data?: IExperimentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentVersionId = _data["experimentVersionId"];
            this.name = _data["name"];
            this.flowsheetUniqueId = _data["flowsheetUniqueId"];
            this.flowsheetVersion = _data["flowsheetVersion"];
            this.processingStatus = _data["processingStatus"];
            this.propertyPackage = _data["propertyPackage"];
            this.separationMethod = _data["separationMethod"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ExperimentComponentResponseModel.fromJS(item));
            }
            if (Array.isArray(_data["streams"])) {
                this.streams = [] as any;
                for (let item of _data["streams"])
                    this.streams!.push(ExperimentStreamResponseModel.fromJS(item));
            }
            if (Array.isArray(_data["specifications"])) {
                this.specifications = [] as any;
                for (let item of _data["specifications"])
                    this.specifications!.push(ExperimentSpecificationPropertyResponseModel.fromJS(item));
            }
            this.convergenceTimeout = _data["convergenceTimeout"];
            this.internalTolerance = _data["internalTolerance"];
            this.externalTolerance = _data["externalTolerance"];
            this.maximumCost = _data["maximumCost"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
            this.totalFlowsheets = _data["totalFlowsheets"];
            this.totalConverged = _data["totalConverged"];
            this.totalNotConverged = _data["totalNotConverged"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ExperimentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentVersionId"] = this.experimentVersionId;
        data["name"] = this.name;
        data["flowsheetUniqueId"] = this.flowsheetUniqueId;
        data["flowsheetVersion"] = this.flowsheetVersion;
        data["processingStatus"] = this.processingStatus;
        data["propertyPackage"] = this.propertyPackage;
        data["separationMethod"] = this.separationMethod;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        if (Array.isArray(this.streams)) {
            data["streams"] = [];
            for (let item of this.streams)
                data["streams"].push(item.toJSON());
        }
        if (Array.isArray(this.specifications)) {
            data["specifications"] = [];
            for (let item of this.specifications)
                data["specifications"].push(item.toJSON());
        }
        data["convergenceTimeout"] = this.convergenceTimeout;
        data["internalTolerance"] = this.internalTolerance;
        data["externalTolerance"] = this.externalTolerance;
        data["maximumCost"] = this.maximumCost;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["totalFlowsheets"] = this.totalFlowsheets;
        data["totalConverged"] = this.totalConverged;
        data["totalNotConverged"] = this.totalNotConverged;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IExperimentResponseModel {
    id?: number;
    experimentVersionId?: number;
    name?: string;
    flowsheetUniqueId?: string;
    flowsheetVersion?: number | undefined;
    processingStatus?: ExperimentProcessingStatus | undefined;
    propertyPackage?: PropertyPackageOption | undefined;
    separationMethod?: SeparationMethodOption | undefined;
    components?: ExperimentComponentResponseModel[];
    streams?: ExperimentStreamResponseModel[];
    specifications?: ExperimentSpecificationPropertyResponseModel[];
    convergenceTimeout?: number | undefined;
    internalTolerance?: number | undefined;
    externalTolerance?: number | undefined;
    maximumCost?: number | undefined;
    createdAt?: Date;
    errorMessage?: string;
    totalFlowsheets?: number;
    totalConverged?: number;
    totalNotConverged?: number;
    isDeleted?: boolean;
}

export enum SeparationMethodOption {
    IdealMixtureDistillation = 1,
    HomogeneousMinimumBoilingAzeotropesWithPressureSwingDistillation = 2,
    HeterogeneousAzeotropeDistillationWithEntrainer = 3,
    Absorption = 4,
}

export class ExperimentComponentResponseModel implements IExperimentComponentResponseModel {
    name?: string;
    componentCasNr?: string;
    isSeparation?: boolean;
    isSolvent?: boolean;
    isEntrainer?: boolean;
    targetValue?: number | undefined;

    constructor(data?: IExperimentComponentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.componentCasNr = _data["componentCasNr"];
            this.isSeparation = _data["isSeparation"];
            this.isSolvent = _data["isSolvent"];
            this.isEntrainer = _data["isEntrainer"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): ExperimentComponentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentComponentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["componentCasNr"] = this.componentCasNr;
        data["isSeparation"] = this.isSeparation;
        data["isSolvent"] = this.isSolvent;
        data["isEntrainer"] = this.isEntrainer;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface IExperimentComponentResponseModel {
    name?: string;
    componentCasNr?: string;
    isSeparation?: boolean;
    isSolvent?: boolean;
    isEntrainer?: boolean;
    targetValue?: number | undefined;
}

export class ExperimentStreamResponseModel implements IExperimentStreamResponseModel {
    name?: string;
    streamType?: ExperimentStreamType | undefined;
    temperature?: number | undefined;
    pressure?: number | undefined;
    massFlowFlowrate?: number | undefined;
    molarFlowFlowrate?: number | undefined;
    compositions?: ExperimentStreamCompositionResponseModel[];

    constructor(data?: IExperimentStreamResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.streamType = _data["streamType"];
            this.temperature = _data["temperature"];
            this.pressure = _data["pressure"];
            this.massFlowFlowrate = _data["massFlowFlowrate"];
            this.molarFlowFlowrate = _data["molarFlowFlowrate"];
            if (Array.isArray(_data["compositions"])) {
                this.compositions = [] as any;
                for (let item of _data["compositions"])
                    this.compositions!.push(ExperimentStreamCompositionResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExperimentStreamResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentStreamResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["streamType"] = this.streamType;
        data["temperature"] = this.temperature;
        data["pressure"] = this.pressure;
        data["massFlowFlowrate"] = this.massFlowFlowrate;
        data["molarFlowFlowrate"] = this.molarFlowFlowrate;
        if (Array.isArray(this.compositions)) {
            data["compositions"] = [];
            for (let item of this.compositions)
                data["compositions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExperimentStreamResponseModel {
    name?: string;
    streamType?: ExperimentStreamType | undefined;
    temperature?: number | undefined;
    pressure?: number | undefined;
    massFlowFlowrate?: number | undefined;
    molarFlowFlowrate?: number | undefined;
    compositions?: ExperimentStreamCompositionResponseModel[];
}

export enum ExperimentStreamType {
    Feed = 1,
    Solvent = 2,
    Entrainer = 3,
}

export class ExperimentStreamCompositionResponseModel implements IExperimentStreamCompositionResponseModel {
    componentCasNr?: string;
    value?: number | undefined;
    isLowBoiling?: boolean;
    isHighBoiling?: boolean;

    constructor(data?: IExperimentStreamCompositionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentCasNr = _data["componentCasNr"];
            this.value = _data["value"];
            this.isLowBoiling = _data["isLowBoiling"];
            this.isHighBoiling = _data["isHighBoiling"];
        }
    }

    static fromJS(data: any): ExperimentStreamCompositionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentStreamCompositionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentCasNr"] = this.componentCasNr;
        data["value"] = this.value;
        data["isLowBoiling"] = this.isLowBoiling;
        data["isHighBoiling"] = this.isHighBoiling;
        return data;
    }
}

export interface IExperimentStreamCompositionResponseModel {
    componentCasNr?: string;
    value?: number | undefined;
    isLowBoiling?: boolean;
    isHighBoiling?: boolean;
}

export class ExperimentSpecificationPropertyResponseModel implements IExperimentSpecificationPropertyResponseModel {
    specificationProperty?: SpecificationProperty | undefined;
    lowerBoundValue?: number | undefined;
    upperBoundValue?: number | undefined;
    defaultValue?: number | undefined;

    constructor(data?: IExperimentSpecificationPropertyResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specificationProperty = _data["specificationProperty"];
            this.lowerBoundValue = _data["lowerBoundValue"];
            this.upperBoundValue = _data["upperBoundValue"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): ExperimentSpecificationPropertyResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentSpecificationPropertyResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specificationProperty"] = this.specificationProperty;
        data["lowerBoundValue"] = this.lowerBoundValue;
        data["upperBoundValue"] = this.upperBoundValue;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IExperimentSpecificationPropertyResponseModel {
    specificationProperty?: SpecificationProperty | undefined;
    lowerBoundValue?: number | undefined;
    upperBoundValue?: number | undefined;
    defaultValue?: number | undefined;
}

export enum SpecificationProperty {
    NumberOfStagesFeedToTop = 1,
    NumberOfStagesBottomToFeed = 2,
    CondenserPressure = 3,
    RefluxRation = 4,
    BottomProductFlowrate = 5,
    HeaterTemperatures = 6,
    NumberOfStages = 7,
    GasPressure = 8,
    SolventTemperature = 9,
    SolventFlowrate = 10,
    SwingPressure = 11,
    NumberOfStagesEntrainerToTop = 12,
    NumberOfStagesFeedToEntrainer = 13,
}

export class ExperimentListResponseModel implements IExperimentListResponseModel {
    totalRecords?: number;
    experiments?: ExperimentResponseModel[];

    constructor(data?: IExperimentListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["experiments"])) {
                this.experiments = [] as any;
                for (let item of _data["experiments"])
                    this.experiments!.push(ExperimentResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExperimentListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.experiments)) {
            data["experiments"] = [];
            for (let item of this.experiments)
                data["experiments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExperimentListResponseModel {
    totalRecords?: number;
    experiments?: ExperimentResponseModel[];
}

export class EditExperimentResponseModel implements IEditExperimentResponseModel {
    experimentId?: number;

    constructor(data?: IEditExperimentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
        }
    }

    static fromJS(data: any): EditExperimentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditExperimentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        return data;
    }
}

export interface IEditExperimentResponseModel {
    experimentId?: number;
}

export class ExperimentPostModel implements IExperimentPostModel {
    id?: number | undefined;
    name!: string;
    flowsheetUniqueId!: string;
    flowsheetVersion!: number;
    propertyPackage!: PropertyPackageOption;
    separationMethod!: SeparationMethodOption;
    components?: ExperimentComponentPostModel[];
    streams?: ExperimentStreamPostModel[];
    specifications?: ExperimentSpecificationPropertyPostModel[];
    convergenceTimeout!: number;
    internalTolerance!: number;
    externalTolerance!: number;
    maximumCost!: number;

    constructor(data?: IExperimentPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.flowsheetUniqueId = _data["flowsheetUniqueId"];
            this.flowsheetVersion = _data["flowsheetVersion"];
            this.propertyPackage = _data["propertyPackage"];
            this.separationMethod = _data["separationMethod"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ExperimentComponentPostModel.fromJS(item));
            }
            if (Array.isArray(_data["streams"])) {
                this.streams = [] as any;
                for (let item of _data["streams"])
                    this.streams!.push(ExperimentStreamPostModel.fromJS(item));
            }
            if (Array.isArray(_data["specifications"])) {
                this.specifications = [] as any;
                for (let item of _data["specifications"])
                    this.specifications!.push(ExperimentSpecificationPropertyPostModel.fromJS(item));
            }
            this.convergenceTimeout = _data["convergenceTimeout"];
            this.internalTolerance = _data["internalTolerance"];
            this.externalTolerance = _data["externalTolerance"];
            this.maximumCost = _data["maximumCost"];
        }
    }

    static fromJS(data: any): ExperimentPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["flowsheetUniqueId"] = this.flowsheetUniqueId;
        data["flowsheetVersion"] = this.flowsheetVersion;
        data["propertyPackage"] = this.propertyPackage;
        data["separationMethod"] = this.separationMethod;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        if (Array.isArray(this.streams)) {
            data["streams"] = [];
            for (let item of this.streams)
                data["streams"].push(item.toJSON());
        }
        if (Array.isArray(this.specifications)) {
            data["specifications"] = [];
            for (let item of this.specifications)
                data["specifications"].push(item.toJSON());
        }
        data["convergenceTimeout"] = this.convergenceTimeout;
        data["internalTolerance"] = this.internalTolerance;
        data["externalTolerance"] = this.externalTolerance;
        data["maximumCost"] = this.maximumCost;
        return data;
    }
}

export interface IExperimentPostModel {
    id?: number | undefined;
    name: string;
    flowsheetUniqueId: string;
    flowsheetVersion: number;
    propertyPackage: PropertyPackageOption;
    separationMethod: SeparationMethodOption;
    components?: ExperimentComponentPostModel[];
    streams?: ExperimentStreamPostModel[];
    specifications?: ExperimentSpecificationPropertyPostModel[];
    convergenceTimeout: number;
    internalTolerance: number;
    externalTolerance: number;
    maximumCost: number;
}

export class ExperimentComponentPostModel implements IExperimentComponentPostModel {
    name!: string;
    componentCasNr!: string;
    isSeparation?: boolean;
    isSolvent?: boolean;
    isEntrainer?: boolean;
    targetValue?: number | undefined;

    constructor(data?: IExperimentComponentPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.componentCasNr = _data["componentCasNr"];
            this.isSeparation = _data["isSeparation"];
            this.isSolvent = _data["isSolvent"];
            this.isEntrainer = _data["isEntrainer"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): ExperimentComponentPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentComponentPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["componentCasNr"] = this.componentCasNr;
        data["isSeparation"] = this.isSeparation;
        data["isSolvent"] = this.isSolvent;
        data["isEntrainer"] = this.isEntrainer;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface IExperimentComponentPostModel {
    name: string;
    componentCasNr: string;
    isSeparation?: boolean;
    isSolvent?: boolean;
    isEntrainer?: boolean;
    targetValue?: number | undefined;
}

export class ExperimentStreamPostModel implements IExperimentStreamPostModel {
    name!: string;
    streamType!: ExperimentStreamType;
    temperature!: number;
    pressure!: number;
    massFlowFlowrate?: number | undefined;
    molarFlowFlowrate?: number | undefined;
    compositions!: ExperimentStreamCompositionPostModel[];

    constructor(data?: IExperimentStreamPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.compositions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.streamType = _data["streamType"];
            this.temperature = _data["temperature"];
            this.pressure = _data["pressure"];
            this.massFlowFlowrate = _data["massFlowFlowrate"];
            this.molarFlowFlowrate = _data["molarFlowFlowrate"];
            if (Array.isArray(_data["compositions"])) {
                this.compositions = [] as any;
                for (let item of _data["compositions"])
                    this.compositions!.push(ExperimentStreamCompositionPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExperimentStreamPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentStreamPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["streamType"] = this.streamType;
        data["temperature"] = this.temperature;
        data["pressure"] = this.pressure;
        data["massFlowFlowrate"] = this.massFlowFlowrate;
        data["molarFlowFlowrate"] = this.molarFlowFlowrate;
        if (Array.isArray(this.compositions)) {
            data["compositions"] = [];
            for (let item of this.compositions)
                data["compositions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExperimentStreamPostModel {
    name: string;
    streamType: ExperimentStreamType;
    temperature: number;
    pressure: number;
    massFlowFlowrate?: number | undefined;
    molarFlowFlowrate?: number | undefined;
    compositions: ExperimentStreamCompositionPostModel[];
}

export class ExperimentStreamCompositionPostModel implements IExperimentStreamCompositionPostModel {
    componentCasNr!: string;
    value!: number;
    isLowBoiling?: boolean;
    isHighBoiling?: boolean;

    constructor(data?: IExperimentStreamCompositionPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentCasNr = _data["componentCasNr"];
            this.value = _data["value"];
            this.isLowBoiling = _data["isLowBoiling"];
            this.isHighBoiling = _data["isHighBoiling"];
        }
    }

    static fromJS(data: any): ExperimentStreamCompositionPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentStreamCompositionPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentCasNr"] = this.componentCasNr;
        data["value"] = this.value;
        data["isLowBoiling"] = this.isLowBoiling;
        data["isHighBoiling"] = this.isHighBoiling;
        return data;
    }
}

export interface IExperimentStreamCompositionPostModel {
    componentCasNr: string;
    value: number;
    isLowBoiling?: boolean;
    isHighBoiling?: boolean;
}

export class ExperimentSpecificationPropertyPostModel implements IExperimentSpecificationPropertyPostModel {
    specificationProperty!: SpecificationProperty;
    lowerBoundValue!: number;
    upperBoundValue!: number;
    defaultValue!: number;

    constructor(data?: IExperimentSpecificationPropertyPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specificationProperty = _data["specificationProperty"];
            this.lowerBoundValue = _data["lowerBoundValue"];
            this.upperBoundValue = _data["upperBoundValue"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): ExperimentSpecificationPropertyPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentSpecificationPropertyPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specificationProperty"] = this.specificationProperty;
        data["lowerBoundValue"] = this.lowerBoundValue;
        data["upperBoundValue"] = this.upperBoundValue;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IExperimentSpecificationPropertyPostModel {
    specificationProperty: SpecificationProperty;
    lowerBoundValue: number;
    upperBoundValue: number;
    defaultValue: number;
}

export class FlowsheetSavedResponseModel implements IFlowsheetSavedResponseModel {
    filename?: string;
    simulatePath?: string;

    constructor(data?: IFlowsheetSavedResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.simulatePath = _data["simulatePath"];
        }
    }

    static fromJS(data: any): FlowsheetSavedResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FlowsheetSavedResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["simulatePath"] = this.simulatePath;
        return data;
    }
}

export interface IFlowsheetSavedResponseModel {
    filename?: string;
    simulatePath?: string;
}

export class SaveExperimentFlowsheetPostModel implements ISaveExperimentFlowsheetPostModel {
    filename!: string;
    experimentVersionId!: number;
    sequence!: number;
    flowsheetId!: number;
    parentUniqueId?: string | undefined;
    uploadConflictAction?: UploadConflictAction | undefined;

    constructor(data?: ISaveExperimentFlowsheetPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.experimentVersionId = _data["experimentVersionId"];
            this.sequence = _data["sequence"];
            this.flowsheetId = _data["flowsheetId"];
            this.parentUniqueId = _data["parentUniqueId"];
            this.uploadConflictAction = _data["uploadConflictAction"];
        }
    }

    static fromJS(data: any): SaveExperimentFlowsheetPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveExperimentFlowsheetPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["experimentVersionId"] = this.experimentVersionId;
        data["sequence"] = this.sequence;
        data["flowsheetId"] = this.flowsheetId;
        data["parentUniqueId"] = this.parentUniqueId;
        data["uploadConflictAction"] = this.uploadConflictAction;
        return data;
    }
}

export interface ISaveExperimentFlowsheetPostModel {
    filename: string;
    experimentVersionId: number;
    sequence: number;
    flowsheetId: number;
    parentUniqueId?: string | undefined;
    uploadConflictAction?: UploadConflictAction | undefined;
}

export enum UploadConflictAction {
    Overwrite = 0,
    KeepBoth = 1,
}

export class LicenseResponseModel implements ILicenseResponseModel {
    hasLicense?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ILicenseResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasLicense = _data["hasLicense"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): LicenseResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasLicense"] = this.hasLicense;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ILicenseResponseModel {
    hasLicense?: boolean;
    errorMessage?: string | undefined;
}

export class StartExperimentCalculationPostModel implements IStartExperimentCalculationPostModel {
    experimentId!: number;
    experimentVersionId!: number;

    constructor(data?: IStartExperimentCalculationPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.experimentVersionId = _data["experimentVersionId"];
        }
    }

    static fromJS(data: any): StartExperimentCalculationPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new StartExperimentCalculationPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["experimentVersionId"] = this.experimentVersionId;
        return data;
    }
}

export interface IStartExperimentCalculationPostModel {
    experimentId: number;
    experimentVersionId: number;
}

export class StopExperimentCalculationPostModel implements IStopExperimentCalculationPostModel {
    experimentId!: number;
    experimentVersionId!: number;

    constructor(data?: IStopExperimentCalculationPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.experimentVersionId = _data["experimentVersionId"];
        }
    }

    static fromJS(data: any): StopExperimentCalculationPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new StopExperimentCalculationPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["experimentVersionId"] = this.experimentVersionId;
        return data;
    }
}

export interface IStopExperimentCalculationPostModel {
    experimentId: number;
    experimentVersionId: number;
}

export class CanStartExperimentResponseModel implements ICanStartExperimentResponseModel {
    hasLicense?: boolean;
    canStart?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ICanStartExperimentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasLicense = _data["hasLicense"];
            this.canStart = _data["canStart"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CanStartExperimentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanStartExperimentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasLicense"] = this.hasLicense;
        data["canStart"] = this.canStart;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICanStartExperimentResponseModel {
    hasLicense?: boolean;
    canStart?: boolean;
    errorMessage?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}